import { SURFBOARD_WEBHOOKS_APPLICATION_SOURCE_TYPE } from '../../enum/surfboard';

export interface PaymentSurfboardMetadata {
  source?: SURFBOARD_WEBHOOKS_APPLICATION_SOURCE_TYPE;
  product?: 'giftcard' | 'corporate' | 'topup';
  // [key: string]: any;
}
